import React from 'react';
import {
    Datagrid,
    TextField,
    ReferenceManyField,
    EditButton,
} from 'react-admin';

import SectionTitle from '../components/SectionTitle';
import { isProductiveRule } from './regla-utils';

const GrillaConfiguraciones = ({showEdit, ...props}) => {
    const hasConfig = props.loaded && props.total > 0;
    return (
        <React.Fragment>
            {hasConfig && <SectionTitle label="resources.configuraciones-generales.title" />}
            <Datagrid rowClick={null}>
                <TextField source="clave" />
                <TextField source="descripcion" />
                <TextField source="valor" />
                {showEdit && <EditButton />}
            </Datagrid>
        </React.Fragment>
    );
};

const ReglaConfiguracionGeneral = ({ link, ...props }) => (
    <React.Fragment>
        <ReferenceManyField
            {...props}
            addLabel={false}
            reference="configuraciones-generales"
            target="idRegla"
            sort={{ field: 'id', order: 'ASC' }}
        >
            <GrillaConfiguraciones showEdit={link === 'edit' && !isProductiveRule(props)}/>
        </ReferenceManyField>
    </React.Fragment>
);

export default ReglaConfiguracionGeneral;
